import { useEffect } from "react";
import { getPathnameWithoutId } from "util/URLUtils";
import useLocation from "routing/useLocation";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const NavigationTelemetry = () => {
  const location = useLocation();
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    if (location.pathname) {
      sendTelemetry("$pageview", {
        app_pathname: getPathnameWithoutId(location.pathname)
      });
    }
  }, [location.pathname, sendTelemetry]);
  return null;
};
export default NavigationTelemetry;
